import { Helmet } from "react-helmet";
import DemoRequestForm from "@/components/DemoRequestForm";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const DemoRequest = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Helmet>
        <title>Book a Demo | benchr.ai - E-commerce Competitive Intelligence & AI Market Analysis Platform</title>
        <meta name="description" content="Request a personalized demo of benchr.ai's AI-powered e-commerce competitive intelligence platform. See how our real-time pricing data and market analysis can help you gain a competitive edge." />
        <meta name="keywords" content="e-commerce demo, competitive intelligence platform, price monitoring demo, market analysis tool, AI e-commerce analytics, competitor tracking software" />
        <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Book a Demo - Benchr E-commerce Competitive Intelligence Platform",
            "description": "Schedule a personalized demonstration of Benchr's AI-powered e-commerce competitive intelligence platform to see how it can help your business.",
            "keywords": ["e-commerce demo", "competitive intelligence platform", "price monitoring demo", "market analysis tool"],
            "publisher": {
              "@type": "Organization",
              "name": "Benchr",
              "logo": {
                "@type": "ImageObject",
                "url": "/lovable-uploads/5b3fc61d-09cc-4356-aca7-ef3a45266769.png"
              }
            },
            "potentialAction": {
              "@type": "BookAction",
              "target": {
                "@type": "EntryPoint",
                "urlTemplate": "https://calendar.google.com/calendar/appointments/schedules/AcZssZ0ixREziCGTZSnjXhuPB0TBIti2X5Ks-ATre2wgAkuMuHqJ4XWW7hldUQxV7WW_GMwHwd9IwfBm?gv=true"
              },
              "result": {
                "@type": "Reservation",
                "name": "Benchr Platform Demo"
              }
            }
          }
        `}
        </script>
      </Helmet>
      <Navbar />
      <div className="pt-28 pb-24 min-h-screen bg-benchr-50 dark:bg-benchr-950">
        <div className="container max-w-7xl mx-auto px-6 md:px-10">
          <DemoRequestForm />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DemoRequest;
